import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util'

const container = theme => css`
  margin: ${rem(32)} auto;
  max-width: ${rem(313)};

  @media only screen and (max-width: ${theme.breakpoints.tabletBreakpoint}) {
    margin: ${rem(24)} auto;
  }

  .ui.button {
    width: 100%;
    border: none;

    &:hover {
      cursor: pointer;
    }
  }
`

const signupWithEmail = theme => css`
  margin-top: ${rem(16)};

  svg {
    rect {
      fill: ${theme.color.primary.info};
    }
  }

  & svg + span {
    min-width: ${rem(155)};
    text-align: start;

    @media only screen and (max-width: ${theme.breakpoints.tabletBreakpoint}) {
      min-width: ${rem(136)};
    }
  }
`

const heading = theme => css`
  margin-top: ${rem(32)};
  letter-spacing: -0.02em;

  @media only screen and (max-width: ${theme.breakpoints.tabletBreakpoint}) {
    margin-top: ${rem(24)};
  }
`

export const styles = {
  container,
  signupWithEmail,
  heading,
}
